import React, { useEffect, useRef, useState } from "react";
import PageHeading from "../common/PageHeading";
import infoIcon from "./info.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Navigation, Pagination } from "swiper/modules";
import { useNavigate, useParams } from "react-router-dom";
import {
  Add_Calender,
  BackArrowIcon,
  ChevronLeft,
  ChevronRight,
  Clock,
  MapIcon,
  Normal_Back_Arrow,
  Normal_Front_Arrow,
  Pin_Location,
} from "../../utils/SvgComponents";
import CustomButton from "../common/button/Button";
import RippleInitializer from "../new-pages/RippleInitializer";
import { apiHandler } from "../../utils/apiHandler";
import { getDataFromStore } from "../../utils/CookiesUtils";
import { EVENT_BASEURL, LOGIN_DATA } from "../../utils/Constants";
import { motion } from "framer-motion";
import BlurImage from "../common/image/image";
import OpenPlaceButton from "./OpenMapButton";


const openInCalender = () => {
  window.location.href = "cal://";
};

const DateAndTime = () => {
  const { id } = useParams();
  const [response, setResponse] = useState([]);
  const [selectedImg, setSelectedImg] = useState(null); // Initial state
  const [currentIndex, setCurrentIndex] = useState(0);
  const [locationTransition, setLocationTransition] = useState('slide-in-right');
  const [startTimeTransition, setStartTimeTransition] = useState('slide-in-right');
  const [addressTransition, setAddressTransition] = useState('slide-in-bottom');
  const [animationClass, setAnimationClass] = useState('slide-in-bottom');
  const [animationClasses, setAnimationClasses] = useState('center');
  const [transition, setTransition] = useState('slide-in');
  const [imageIndex, setImageIndex] = useState(currentIndex);
  const [fadeClass, setFadeClass] = useState('');
  const [newIndex, setNewIndex] = useState(0)
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  // const [fadeClass, setFadeClass] = useState('fade-out');
  let NewUsername = "";

  const pathArray = window.location.pathname.split("/").filter(Boolean);

  if (pathArray.includes("Login")) {
    // Handle special case when URL contains "Login"
    NewUsername = pathArray[1];
  } else {
    NewUsername = pathArray[0]
  }

  let data = JSON.parse(localStorage.getItem(`logindata_${NewUsername}`))
  const newImgUrl = `https://welcometowedding.com/events/${data?._id}/`
  console.log(newImgUrl);
  //alert(data?._id);

  const prevIndexRef = useRef(imageIndex);

  useEffect(() => {
    const fetchDate_Time = async () => {
      try {
        const res = await apiHandler.post("/guest/fetch-feature", {
          _id: id,
          category: "DateAndTimings"
        });
        console.log(res);
        if (res) {
          console.log(res.functions)
          setResponse(res.functions);
          // Set the initial image after response is received
          if (res.functions && res.functions.length > 0 && res.functions[0].venue && res.functions[0].venue[0]?.imgs && res.functions[0].venue[0]?.imgs[0]) {
            handleSelectImg(newImgUrl + res.functions[0].venue[0].imgs[0])
          }
        }
      } catch (err) {
        console.error("Guest login error:", err);
      }
    };

    fetchDate_Time();
  }, [])

  const renderCustomPagination = (swiper, current, total) => {
    return `<div class="${animationClasses}" >${current} / ${total}</div>`;
  };





  useEffect(() => {
    // Get the previous index from ref
    const prevIndex = prevIndexRef.current;
    // Update the ref with the current index for next render
    prevIndexRef.current = imageIndex;
    const reslength = response && response.length;

    // Determine if we are moving to the next or previous slide
    const isNext = (imageIndex - prevIndex + reslength) % reslength === 1;

    // if (response.length > 0) {
    //   console.log("Select IMage ," ,)
    //   setSelectedImg(response[0].image);
    //   if(response[currentIndex].venue[0].imgs[0] ){
    //     setImageIndex(EVENT_BASEURL+response[currentIndex].venue[0].imgs[0])
    //   }
    //   handleSelectImg(EVENT_BASEURL+response[currentIndex].venue[0].imgs[0])
    // }

    // Apply transition classes based on the direction of slide change
    if (isNext) {
      setLocationTransition('slide-out-left');
      setStartTimeTransition('slide-out-left');
      setAddressTransition('slide-out-top');
      setAnimationClasses('center-to-left');
      setAnimationClass('slide-out-top');

      // Apply the slide-in animation after a delay
      const timer = setTimeout(() => {
        setLocationTransition('slide-in-right');
        setStartTimeTransition('slide-in-right');
        setAddressTransition('slide-in-bottom');
        setAnimationClass('slide-in-bottom');
        setAnimationClasses('left-to-center');
      }, 100);
      if (response) {
        handleSelectImg(newImgUrl + response[imageIndex]?.venue[0]?.imgs[0])
      }

      return () => clearTimeout(timer);
    } else {
      setLocationTransition('slide-out-right');
      setStartTimeTransition('slide-out-right');
      setAddressTransition('slide-out-bottom');
      setAnimationClasses('center-to-right');
      setAnimationClass('slide-out-bottom');


      // Apply the slide-in animation after a delay
      const timer = setTimeout(() => {
        setLocationTransition('slide-in-left');
        setStartTimeTransition('slide-in-left');
        setAddressTransition('slide-in-top');
        setAnimationClass('slide-in-top');
        setAnimationClasses('right-to-center');
      }, 100);
      if (response) {
        handleSelectImg(newImgUrl + response[imageIndex]?.venue[0]?.imgs[0])
      }

      return () => clearTimeout(timer);
    }
  }, [imageIndex, response]);


  useEffect(() => {
    changeSlide();
  }, [imageIndex]);

  const changeSlide = () => { };


  const handleSelectImg = (img) => {
    setIsImageLoaded(false); // Reset blur state for new image
    setSelectedImg(img);
  };
  const handleNextSlide = () => {
    // console.log(imageIndex)
    // setImageIndex((prevIndex) => (prevIndex + 1) );
  };

  const handlePrevSlide = () => {
    // setImageIndex((prevIndex) => (prevIndex - 1 ) );
  };


  useEffect(() => {
    setFadeClass('fade-in-unvisibal');
    const timer = setTimeout(() => {
      setImageIndex(imageIndex);
      setFadeClass('fade-in-visibal ');
    }, 150); // Match this duration with the CSS transition time

    return () => clearTimeout(timer); // Cleanup on unmount
  }, [imageIndex]);


  function formatTimeRange(startTime, endTime) {
    const start = new Date(startTime);
    const optionsDate = { day: '2-digit', month: 'short' }; // "08 Jul"
    const optionsTime = { hour: 'numeric', minute: '2-digit', hour12: true }; // "9:00 AM"

    const formattedStartDate = start.toLocaleDateString('en-GB', optionsDate);
    const formattedStartTime = start.toLocaleTimeString('en-US', optionsTime);

    if (!endTime) {
      // If endTime is missing
      return `${formattedStartDate} ${formattedStartTime} onwards`;
    }

    const end = new Date(endTime);
    const formattedEndDate = end.toLocaleDateString('en-GB', optionsDate);
    const formattedEndTime = end.toLocaleTimeString('en-US', optionsTime);

    const sameDate =
      start.getFullYear() === end.getFullYear() &&
      start.getMonth() === end.getMonth() &&
      start.getDate() === end.getDate();

    if (sameDate && start.getTime() === end.getTime()) {
      return `${formattedStartDate} ${formattedStartTime} onwards`;
    } else if (sameDate) {
      return `${formattedStartDate} ${formattedStartTime} - ${formattedEndTime}`;
    } else {
      return `${formattedStartDate} ${formattedStartTime} - ${formattedEndDate} ${formattedEndTime}`;
    }
  }

  const itemVariants = {
    hidden: { opacity: 0, },
    show: { opacity: 1, transition: { duration: 1.0, ease: "easeOut" } },
  };

  console.log("Value of venue ", response[imageIndex]?.venue.length)

  return (
    <div style={{ zIndex: '333333', backgroundColor: 'white' }}>
      <div className="hidden sm:block h-screen " >
        <div className="grid grid-cols-12 h-full">
          <div className="col-span-5 h-full">
            <motion.div variants={itemVariants}
              className={`image h-full bg-center bg-cover w-full flex items-end `}
              style={{ position: "relative" }}
            >
              <div variants={itemVariants} className="image-container">
                {selectedImg && <BlurImage
                  src={selectedImg}
                  alt=""
                  className={`image-photo image`}
                />}
              </div>
              {

                response.length > 0 && response[imageIndex]?.venue.length > 1 && <div className={`w-full p-[1.25rem] bg-black/70 flex justify-center items-center gap-[1rem] overflow-x-auto ${fadeClass}`} style={{ position: "absolute" }}>
                  {response && response[imageIndex]?.venue.map((item, i) => (
                    <div
                      key={i}
                      className={`w-[200px] rounded-md overflow-hidden cursor-pointer dashboard-pc-main-card border-white border-[2.35px] relative whiteripple   `}
                      onClick={() => {
                        if (item.imgs?.[0]) {
                          handleSelectImg(
                            `${newImgUrl}${item.imgs[0]}`
                          )
                        }
                        setNewIndex(i)
                      }
                      }
                    >
                      {item.imgs?.[0] && <BlurImage
                        src={`${newImgUrl}${item.imgs[0]}`}
                        alt=""
                        className="w-full h-[180px]"
                      />}
                      <div className="absolute text-center leading-[30px] w-full bottom-0 left-1/2 translate-x-[-50%] bg-black/60 border-t-[2.35px] border-white flex items-center font-medium text-lg">
                        <span className={`hvr-sweep-to-right ${newIndex == i ? "bg-black" : ''} `}>{item?.title}</span>
                      </div>
                    </div>
                  ))}
                </div>
              }
            </motion.div>
          </div>
          <div className="col-span-7 h-[10vh] pt-4 black-color" >
            <PageHeading title={"Date & Timings"} />
            <motion.div variants={itemVariants}>
              <Swiper
                effect={"coverflow"}
                grabCursor={true}
                slideToClickedSlide={true}
                // loop={true}
                centeredSlides={true}
                slidesPerView={4}
                slidesPerGroup={1}
                onSlideChange={(swiper) => {
                  setImageIndex(swiper.activeIndex);
                }}
                // slidesPerGroupAuto={true}
                // loopAddBlankSlides={true}
                freeMode={true}
                // updateOnWindowResize={true}
                autoHeight={true}
                keyboard={true}
                coverflowEffect={{
                  rotate: 0,
                  stretch: 90,
                  depth: 30,
                  modifier: 1,
                  slideShadows: false,
                }}


                // onUpdate={responseData}
                navigation={{
                  enabled: true,
                  nextEl: "#custom-next-button",
                  prevEl: "#custom-prev-button",
                }}
                pagination={{
                  enabled: true,
                  clickable: true,
                  type: "bullets",
                  el: "#custom-pagination",
                }}
                modules={[EffectCoverflow, Pagination, Navigation]}
                className="mySwiper"
                // initialSlide={2}
                speed={500}
                spaceBetween={80}
              >
                {response && response.map((item, index) => (
                  <SwiperSlide key={index}>
                    <div className="border-[3px] rounded-lg overflow-hidden shadow-2xl ">
                      {item.fnImg && <BlurImage src={newImgUrl + item.fnImg} ></BlurImage>}

                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
              <div>
                <div div className='w-full'>
                  <div className="flex justify-around items-center mx-40">
                    <button id="custom-prev-button" onClick={handlePrevSlide} style={{ visibility: imageIndex === 0 ? 'hidden' : 'visible' }}>
                      <ChevronLeft style={{ height: '40px', width: '40px' }} />
                    </button>
                    <div className="flex-grow flex justify-center">
                      <div className="font-bold text-[20px] text-center" style={{ maxWidth: '300px' }}>
                        <div className={`text-center ${animationClasses}`}>
                          {response && response[imageIndex]?.fnTitle}
                        </div>
                      </div>
                    </div>
                    <button id="custom-next-button" onClick={handleNextSlide} style={{ visibility: imageIndex === (response?.length > 0 ? response.length - 1 : 0) ? 'hidden' : 'visible' }}>
                      <ChevronRight style={{ height: '40px', width: '40px' }} />
                    </button>
                  </div>

                </div>
                <div style={{ textAlign: 'center' }}>
                  <div
                    id="custom-pagination"
                    className="w-auto"
                  ></div>
                </div>
                <div style={{ width: "100%", overflow: "hidden" }}>
                  <div className={`flex justify-center items-center  ${animationClasses}`} >
                    <div className={`flex justify-center items-center  `}>
                      {response && response[imageIndex]?.venueName && <div className="p-[5px]">
                        <Pin_Location width="24" />
                      </div>}
                      {response && response[imageIndex]?.venueName}
                    </div>
                    <div className={`flex justify-center items-center p-3 `}>
                      <div className="p-[5px]">
                        <Clock width="24" />
                      </div>
                      {response && formatTimeRange(response[imageIndex]?.startTime, response[imageIndex]?.endTime)}
                    </div>
                    {response[imageIndex]?.info && <div className={`flex justify-center items-center p-3 `}>
                      <div className="p-[5px]">
                        {/* <Clock width="24" /> */}
                        <img src={infoIcon} alt="info" />
                      </div>
                      {response && response[imageIndex]?.info}
                    </div>}
                  </div>
                </div>
                <div className={`text-center ${animationClass}`}>
                  {response && response[imageIndex]?.address}
                </div>
              </div>
              {
                (response && response[imageIndex]?.latlng) && <div className="flex justify-center gap-3 mt-7">
                  {/* <button
                  className="bg-black text-white text-[13px] px-3 rounded-full flex justify-center items-center whiteripple"
                  onClick={() => openInCalender()}
                >
                  <div className="p-[5px]">
                    <Add_Calender width="22" fill="white" />
                  </div>
                 <span className="p-1 py-2"> Add to Calender</span>
                </button> */}
                  <OpenPlaceButton
                    customClass="bg-black text-white text-[13px] px-3 rounded-full flex justify-center items-center whiteripple"
                    link={response && response[imageIndex]?.latlng}
                  />
                </div>
              }
            </motion.div>
          </div>
        </div>
      </div>
      <div className="sm:hidden h-[100svh] relative overflow-hidden pt-[1.25rem] flex flex-col ">
        <div className="flex-none">
          <div className="date-timing">
            <Swiper
              effect={"coverflow"}
              grabCursor={true}
              slideToClickedSlide={true}
              centeredSlides={true}
              slidesPerView={3}
              onRealIndexChange={(e) => setImageIndex(e.realIndex)}
              freeMode={true}
              autoHeight={true}
              keyboard={true}
              coverflowEffect={{
                rotate: 0,
                stretch: 0,
                depth: 0,
                modifier: 1,
                scale: 0.75,
                slideShadows: false,
              }}
              navigation={{
                nextEl: "#mobile-arrow-right",
                prevEl: "#mobile-arrow-left",
              }}
              pagination={{
                type: 'custom',
                renderCustom: renderCustomPagination,
              }}
              modules={[EffectCoverflow, Pagination, Navigation]}
              className="mySwiper date-and-time-slider"
              speed={500}
            >
              <div className={`text-center font-semibold text-[25px] absolute top-0 ps-10 ${animationClasses}`}>
                {response && response[imageIndex]?.fnTitle}
              </div>
              {response && response.map((item, index) => (
                <SwiperSlide key={index} className="">
                  <div className="rounded-lg overflow-hidden shadow-md shadow-black/20">
                    {item.fnImg && <img
                      src={newImgUrl + item.fnImg}
                      alt=""
                      className={`transition-all duration-500 ${!isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"}`}
                      onLoad={() => setIsImageLoaded(true)}
                    />}
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

          </div>
          <div className="px-[20px]">
            <div className="font-medium text-[22px] ps-6 overflow-hidden">
              <div id="mobile-location" >
                <div className={` ${animationClass}`}>{response && response[imageIndex]?.venueName}</div>
                {/* <div>{response && response[imageIndex]?.fnTitle}</div> */}
              </div>
            </div>
            <div className="flex justify-start pt-[10px]">
              <div className="pe-1">
                <Pin_Location width="20" />
              </div>
              <div className={` ${animationClasses}`} >{response && response[imageIndex]?.address}</div>
            </div>
            <div className="flex justify-start items-center pt-[10px]">
              <div className="pe-1">
                <Clock width="20" />
              </div>
              <div className={` ${animationClass}`}>{response && formatTimeRange(response[imageIndex]?.startTime, response[imageIndex]?.endTime)}</div>
            </div>
            {
              response && response[imageIndex]?.info && <div className="flex justify-start items-center pt-[10px]">
                <div className="pe-1">
                  {/* <Clock width="20" /> */}
                  <img src={infoIcon} alt="info" width="20" />
                </div>
                <div className={` ${animationClass}`}>{response && response[imageIndex]?.info}</div>
              </div>
            }

          </div>
        </div>
        <div className="relative mt-[30px] flex-auto">
          <div className="absolute z-10 top-[-17px] left-0 right-0">
            <div className={`mx-auto flex justify-center gap-[17px]  ${fadeClass}`} >
              {response && response[imageIndex]?.venue.length > 1 && response[imageIndex]?.venue.map((item, i) => (
                <div className="rounded-md overflow-hidden " >
                  <div key={i} onClick={() => {
                    setNewIndex(i)
                    if (item.imgs?.[0]) {
                      handleSelectImg(
                        `${newImgUrl}${item.imgs[0]}`
                      )
                    }
                  }
                  } className={`${newIndex == i ? "bg-black text-white" : 'bg-white text-black'}   border-[1.5px] border-black py-1 px-4 rounded-md buttonripple`}>
                    {item?.title}
                  </div>
                </div>
              ))}
              {/* <div className="rounded-md overflow-hidden " >

                  <div className="bg-black text-white border border-black py-1 px-6 rounded-md whiteripple">
                    Map
                  </div>

              </div>

                <div className="bg-white text-black border-[1.5px] border-black py-1 px-4 rounded-md buttonripple">
                  Rooms
                </div>

                <div className="bg-white text-black border-[1.5px] border-black py-1 px-4 rounded-md buttonripple">
                  Garden
                </div> */}
            </div>
          </div>
          <div className="image-container">
            {selectedImg &&
              <img
                src={selectedImg}
                alt=""
                className={`image transition-all duration-500 ${!isImageLoaded ? "blur-lg scale-105" : "blur-0 scale-100"}`}
                onLoad={() => setIsImageLoaded(true)}
              />
            }
          </div>
          <div className="absolute top-0 left-0 right-0 text-center bg-gradient-to-b from-white via-white-opacity-50 to-transparent text-transparent py-5">
            H
          </div>
        </div>
        <div className="absolute w-full bottom-0 left-0 pb-[12px] px-[50px] flex justify-between items-center ">
          <div
            id="mobile-arrow-left"
            className={`${imageIndex === 0 ? "opacity-0 pointer-events-none" : ""}`}
          >
            <CustomButton
              clicked={() => { }}
              className="buttonripple"
              borderRadius={"100%"}
              bgColor={"black"}
              paddingX={"11px"}
              paddingY={"11px"}
              minWidth={"0"}
              animationDuration="0s"
            >
              <Normal_Back_Arrow width="25" height="25" fill="white" />
            </CustomButton>
          </div>
          <div>
            <OpenPlaceButton
              link={response && response[imageIndex]?.latlng}
              isMobile={true}
            />
          </div>
          <div
            id="mobile-arrow-right"
            className={`${imageIndex === (response?.length > 0 ? response.length - 1 : 0) ? "opacity-0 pointer-events-none" : ""}`}
          >
            <CustomButton
              clicked={() => { }}
              className="buttonripple"
              borderRadius={"100%"}
              bgColor={"black"}
              paddingX={"11px"}
              paddingY={"11px"}
              minWidth={"0"}
              animationDuration="0s"
            >
              <Normal_Front_Arrow width="25" fill="white" />
            </CustomButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateAndTime;
